import React, { Component, ReactNode } from 'react'
import Icon from './Icon'

interface Props {
  name?: string
  onClick?: () => void
  children: ReactNode
}

export default class InputIcon extends Component<Props> {
  get icon () {
    const { name, onClick } = this.props
    return name &&
      <div className="bg-transparent pl-1 absolute right-3 top-2">
        <Icon
          name={name}
          size="small"
          color="light"
          onClick={onClick} />
      </div>
  }

  render () {
    return (
      <div className="relative">
        {this.props.children}
        {this.icon}
      </div>
    )
  }
}
